import { BettingOptionsFormat } from '@betgames/bg-tools';
import { IAuthUrlParams, IAuthValidatedParams } from '@bg-shared/business/Auth/interfaces';
import { DEFAULT_LANGUAGE, DEFAULT_PARTNER_TOKEN } from '@bg-shared/constants/constants';
import {
    IDateFormatKey,
    DATE_FORMAT_BY_COUNTRY,
    DEFAULT_DATE_FORMAT_KEY,
} from '@bg-shared/constants/dateFormats';
import { GameId } from '@bg-shared/enums/GameId';
import { getLocalTimezone } from '@bg-shared/utils/getLocalTimezone';
import { parseCustomBettingAmounts } from './utils/parseCustomBettingAmounts';

export default class AuthValidator {
    private validateTimezone(timezone: string): number {
        const value = Number(timezone?.replace(',', '.'));

        if (!Number.isNaN(value) && value >= -12 && value <= 14) {
            return value;
        }

        return getLocalTimezone();
    }

    private validateDateTimeFormat(format: IDateFormatKey): IDateFormatKey {
        if (DATE_FORMAT_BY_COUNTRY[format]) {
            return format;
        }

        return DEFAULT_DATE_FORMAT_KEY;
    }

    public validateQueryParams(params: IAuthUrlParams): IAuthValidatedParams {
        const singleGameIdNumber = Number(params.singleGame);
        const locale = params.locale || params.language;
        const gameId = params.gameId || params.defaultGame || params.pageName;

        return {
            apiUrl: params.apiUrl,
            partnerCode: _featuresConfig.fallbackPartnerCode ?? params.partnerCode,
            partnerUrl: params.partnerUrl,
            partnerToken: params.token || params.partnerToken || DEFAULT_PARTNER_TOKEN,
            timezone: this.validateTimezone(params.timezone),
            language: locale ? locale.toLowerCase() : DEFAULT_LANGUAGE,
            oddsFormat: Object.values(BettingOptionsFormat).includes(
                params.oddsFormat as BettingOptionsFormat,
            )
                ? (params.oddsFormat as BettingOptionsFormat)
                : BettingOptionsFormat.DECIMAL,
            singleGame: singleGameIdNumber in GameId ? singleGameIdNumber : null,
            bettingAmounts: params.bettingAmounts
                ? parseCustomBettingAmounts(params.bettingAmounts)
                : undefined,
            sid: params.sid,
            homeUrl: params.homeUrl,
            redirect: params.redirect,
            themeEditor: !!Number(params.themeEditor),
            newIntegration: !!Number(params.newIntegration) ?? false,
            scriptIntegration: !!Number(params.scriptIntegration) ?? false,
            onlyGUI: params.onlyGUI ? !!Number(params.onlyGUI) : undefined,
            defaultGUI: params.defaultGUI ? !!Number(params.defaultGUI) : undefined,
            defaultGame: Number(gameId) ?? undefined,
            dateTimeFormat: this.validateDateTimeFormat(params.dateTimeFormat as IDateFormatKey),
            wsUrl: params.wsUrl,
            scrolling: !!Number(params.scrolling),
            lobbyLiveGames: !!Number(params.lobbyLiveGames),
            lobbyDefaultTab: Number(params.lobbyDefaultTab) || 0,
            rgs: {
                token: params.rgsToken,
                login: params.rgsLogin,
            },
        };
    }
}

export const authValidator = new AuthValidator();
